import html2canvas from 'html2canvas';

const isEmpty = (obj) => Object.keys(obj || {}).length === 0;

/**
 *
 * @param obj
 * @returns {boolean}
 */
const isNotEmpty = (obj) => !isEmpty(obj);

/**
 *
 * @param obj
 * @returns {boolean}
 */
const isTrue = (obj) => `${obj}`.toLowerCase().trim() === 'true' || `${obj}`.toLowerCase().trim() === '1';

/**
 *
 * @param num
 * @returns {boolean}
 */
const isNumeric = (num) => {
	const intN = Number.parseInt(num, 10);
	return typeof intN === 'number' && !Number.isNaN(intN);
};

/**
 *
 * @param keys
 * @param obj
 * @param defVal
 * @returns {*}
 */
const safeGet = (obj, keys, defVal = null) =>
	keys.reduce((prevObj, key) => (prevObj && prevObj[key] ? prevObj[key] : defVal), obj);

/**
 * 禁止用在大的 object 上
 * @param obj1
 * @param obj2
 * @returns {boolean}
 */
const isEquals = (obj1, obj2) => {
	if ((isEmpty(obj1) && !isEmpty(obj2)) || (!isEmpty(obj1) && isEmpty(obj2))) {
		return false;
	}
	//
	const o1Keys = Object.keys(obj1);
	const o2Keys = Object.keys(obj2);
	if (o1Keys.length !== o2Keys.length) {
		return false;
	}
	//
	// eslint-disable-next-line consistent-return
	o1Keys.forEach((key) => {
		if (!o2Keys.includes(key)) {
			return false;
		}
	});
	// eslint-disable-next-line consistent-return
	o2Keys.forEach((key) => {
		if (!o1Keys.includes(key)) {
			return false;
		}
	});
	//
	const sortedKeys = [...new Set([...o1Keys, ...o2Keys].sort())];
	const newObj1 = JSON.stringify(sortedKeys.map((key) => ({ [key]: obj1[key] })));
	const newObj2 = JSON.stringify(sortedKeys.map((key) => ({ [key]: obj2[key] })));
	return newObj1 === newObj2;
};

const getDate = () => {
	const nowDate = new Date();
	const mm = nowDate.getMonth() + 1;
	const dd = nowDate.getDate();
	return [nowDate.getFullYear() - 1911, (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
};

const getFormatUser = (user) => {
	const { uid, displayName, email, emailVerified, isAnonymous, providerData } = user;
	const { providerId } = providerData && providerData[0];
	return {
		uid,
		displayName,
		email,
		emailVerified,
		isAnonymous,
		providerId: providerId || 'unKnown',
	};
};

const exportImage = async (element, options = {}) => {
	try {
		const fileName = options.fileName || 'image.png';
		const resolution = options.resolution || 3;
		const canvas = await html2canvas(element, {
			useCORS: true,
			scale: resolution,
		});
		const url = canvas.toDataURL('image/png', 1);
		const aTag = document.createElement('a');
		aTag.href = url;
		aTag.download = fileName;
		document.body.appendChild(aTag);
		aTag.click();
		aTag.remove();
		// export image successfully
		return Promise.resolve({ finish: true });
	} catch (err) {
		// failed to export image
		return Promise.reject(err);
	}
};

export { isEmpty, isNotEmpty, isTrue, isNumeric, safeGet, isEquals, getDate, getFormatUser, exportImage };
